import { getAuth } from "../globals/authentication";

export const getUserBasicDetailFromAuth = () => {
  const authDetails = getAuth();
  const { role, user, is_internal_login } = authDetails || {};
  const { app_user, username: user_code } = user || {};
  const { full_name, phone_number, id: app_user_id } = app_user || {};
  return {
    full_name,
    phone_number,
    role,
    user_code,
    app_user_id,
    is_internal_login,
  };
};
